package ui.styles

import emotion.css.ClassName
import web.cssom.ClassName

object SelectorStyle {
    val selectorHandler = ClassName(ClassName("selector_handler")){

    }

}